import { getMyTaskBacklogTotalNum } from './getMyTaskTotalNum'

/**
 * 对菜单 name 做自定义文案渲染，支持 Promise
 * 由于菜单没有一个固定的 key，此处使用 name 字段作为唯一识别
 * @param {string} name 入参为原文案
 * @return {string | Promise<string>}
 */
const menuNameCustomConf: Record<string, any> = {
  // 我的待办: async (name: string) => {
  //   try {
  //     let totalNum: any = await getMyTaskBacklogTotalNum()
  //     totalNum = Number(totalNum)
  //     if (!Number.isNaN(totalNum)) {
  //       if (totalNum > 99) totalNum = '99+'
  //       return `${name} ${totalNum}`
  //     }
  //     return name
  //   } catch (error) {
  //     return name
  //   }
  // }
}

// 封装为闭包形式
function confProvider(conf: Record<string, any>) {
  const res: Record<string, any> = {}
  Object.keys(conf).forEach((key: string) => {
    res[key] = (n: string) => () => conf[key](n)
  })
  return res
}

export const menuNameCustomFuns = confProvider(menuNameCustomConf)
